import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import {CompService} from './sidebar.model';

@Injectable()
export class SidebarService {

  constructor() { }
  getComponents (): Observable<CompService[]> {
    //   return this.http.get<Component[]>(this.url)
    //     .pipe(
    //       tap(services => this.log(`fetched services`)),
    //       catchError(this.handleError('getServices', []))
    //     );

    return of([
      {id: 1, name: 'entitlement', selected: 'active-tab'},
      {id: 2, name: 'identity', selected: ''},
      {id: 3, name: 'developer_portal', selected: ''}
      // {id: 4, name: 'component', selected: ''},
      // {id: 5, name: 'component', selected: ''},
      // {id: 6, name: 'component', selected: ''},
      // {id: 7, name: 'component', selected: ''},
      // {id: 8, name: 'component', selected: ''},
      // {id: 9, name: 'component', selected: ''}
    ]);
  }
}



// WEBPACK FOOTER //
// ./src/app/sidebar/sidebar.service.ts